/**
 * dnclient's container recipes, published at <https://hub.docker.com/r/definednet/dnclient>.
 * `--network host` and `NET_ADMIN` let dnclient create its tun device on the host; the named
 * `defined` volume outlives the container, so a replacement reuses the existing enrollment instead
 * of needing a fresh code.
 */
export function dockerRunCommand(code: string | undefined): string[] {
  return [
    'docker run \\',
    '    --name dnclient \\',
    '    --network host \\',
    '    --cap-add NET_ADMIN \\',
    '    --volume defined:/etc/defined \\',
    `    --env DN_ENROLLMENT_CODE="${code ?? '<loading…>'}" \\`,
    '    --rm \\',
    '    definednet/dnclient',
  ];
}

/** The same deployment as a Compose service, for `docker compose up -d`. */
export function dockerComposeFile(code: string | undefined): string[] {
  return [
    "version: '2'",
    'services:',
    '  dnclient:',
    '    image: definednet/dnclient',
    '    network_mode: host',
    '    cap_add:',
    '      - NET_ADMIN',
    '    volumes:',
    '      - defined:/etc/defined',
    '    environment:',
    `      - DN_ENROLLMENT_CODE=${code ?? '<loading…>'}`,
    '    restart: unless-stopped',
    'volumes:',
    '  defined:',
  ];
}
